import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatistikService } from '../../statistik.service';
import { combineLatest, Observable, Subject } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { StatistikNorm } from '../../models/StatistikNorm';

@Component({
    selector: 'app-statistik-normtid',
    template: `
        <app-statistik-normtid-ui
            [statistikNormTid]="norm$ | async"
            [periode]="periode$ | async"
            (periodeChange)="periodeChange($event)"
        ></app-statistik-normtid-ui>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikNormtidContainer {
    periodeSubject = new Subject<string>();
    periode$ = this.periodeSubject.asObservable();
    norm$: Observable<StatistikNorm[]> = combineLatest([
        this.statistikService.visible$,
        this.statistikService.step$,
        this.periode$
    ]).pipe(
        filter(([visible, step]) => visible && step === 7),
        switchMap(([, , periode]) => this.statistikService.getNorm(periode))
    );

    constructor(
        private statistikService: StatistikService,
    ) { }

    periodeChange(periode: string) {
        this.periodeSubject.next(periode);
    }
}

